import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
  name: 'safeId',
  standalone: false
})
export class SafeIdPipe implements PipeTransform {
  transform(value: string | null | undefined): any {
    if (!value) return '';
    return value
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-_]/g, '');
  }
}
